<template>

        <div class="login">
            <body class="account-page" style="font-family: 'Quicksand', sans-serif;
                font-size: .9375rem;
                color: #1f1f1f;
                background-color: #f7f7f7;
                min-height: 100%;
                overflow-x: hidden;"
            >
            
                <div class="main-wrapper">
				    <div class="account-content" style="padding: 35px 0;">
                        <!-- <router-link to="/joblist"" class=" btn btn-primary apply-btn">Apply Job</router-link> -->
                        <div class="container">
                            <!-- Account Logo -->
                            <div class="account-logo">
                                <router-link to="/index"><img src="../../assets/logo.png" alt="Dreamguy's Technologies">
                                </router-link>
                            </div>
                            <!-- /Account Logo -->

                                <div class="account-box">
							    <div class="account-wrapper">
									<div class="row">
									<div class="col-md-3">
										<div class="account-logo">
							<router-link to="/index"><img :src="logo" v-if="logo" alt="Sapphire HR"> <img src="../../assets/logo.png" v-if="!logo" alt="Sapphire HR">
							</router-link>
						</div>
									</div>
									<div class="col-md-9">
										<h3 class="account-title">Change Password</h3>
										
									</div>
								
								</div>
								<!-- <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="error">
									<strong>Error</strong>
									<button type="button" class="close" data-dismiss="alert" aria-label="Close">
										<span aria-hidden="true">&times;</span>
									</button>
								</div> -->
								<!-- Account Form -->
								<form @submit.prevent="changePassword">
									<div class="form-group">
										<div class="row">
											<div class="col">
												<label>Current Password</label>
											</div>
										</div>
										<input type="password" v-model="oldPassword"  name="password" class="form-control" />	
									</div>
                                    <div class="form-group">
										<div class="row">
											<div class="col">
												<label>New Password</label>
											</div>
											
										</div>
										<input type="password" v-model="newPassword"  name="password" class="form-control" />                						
									</div>
                                    <div class="form-group">
										<div class="row">
											<div class="col">
												<label>Confirm New Password</label>
											</div>
										</div>
										<input type="password" v-model="confirmPassword"  name="password" class="form-control" />
									</div>
                                    <div class="row">
                                        <div class="form-group text-center col-6">
										    <button class="btn btn-primary account-btn">Change</button>
									    </div>
                                        <div class="form-group text-center col-6">
                                            <button class="btn btn-primary account-btn">Cancel</button>
                                        </div>
                                    </div>
								</form>
								<!-- /Account Form -->
							</div>
						</div>
                        </div>
                    </div>
                </div>
            </body>
	    </div>
      
</template>

<script>
import { authenticationService } from "@/services/authenticationService";
import { organizationService } from '@/services/organizationService';
export default {


  data() {
	return {
		oldPassword: "",
		newPassword: "",
		confirmPassword: "",
		logo: '',
		message: "",
		error: "",
	}
  },
  methods: {
	  getOrg() {
      		organizationService.getOrganization().then(
        		o=> { this.theme = o.theme; this.logo = o.logo }
      )
    },
	changePassword() {

		console.log("change password 1")

		if (this.newPassword !== this.confirmPassword) {
			console.log("passwords do not match")
			return;
		}

		console.log("change password 2")
		authenticationService.changePassword(this.oldPassword, this.newPassword, this.confirmPassword)
			.then(
				user => {
					console.log("change password 3")
					console.log('password successfully changed');
					return this.$router.push('/login');
				},
				error => {
					console.log("change password error", error)
				}
			);
	}
  },  
  mounted() {
	  this.getOrg()
  },
  name: "changePassword",
};
</script>


// WEBPACK FOOTER //
// src/components/auth/changePassword.vue